import { t } from 'i18next'
import z from 'zod'

import { validarImobiliariasCorretoresDuplicados } from '@/features/proposta/shared/domain/schemas/imobiliaria-corretor-duplicado-validator'
import { assinaturaContratoEnum, formaPagamentoComissaoEnum } from '@/types/proposta'

export const ImobiliariaCorretoresSchema = z.discriminatedUnion('incluirParticipacoes', [
  z.object({
    incluirParticipacoes: z.literal('Sim'),
    formaPagamentoComissao: z.enum(formaPagamentoComissaoEnum),
    participacoes: z
      .array(
        z.object({
          imobiliariaCorretor: z
            .object({
              idExterno: z.string(),
              descricao: z.string(),
              nome: z.string(),
              tipoImobiliariaCorretor: z.enum(['Imobiliaria', 'CorretorAutonomo', '']),
              documento: z.string(),
            })
            .refine(
              ({ idExterno }) => idExterno,
              t('proposta:detalhes_proposta.imobiliaria.errors.form.selecao_obrigatoria'),
            ),
          corretagem: z.discriminatedUnion('tipo', [
            z.object({
              tipo: z.literal('percentual'),
              percentualCorretagemImobiliaria: z.coerce
                .number<number>()
                .gt(0, t('proposta:detalhes_proposta.imobiliaria.errors.form.valor_invalido'))
                .lte(100, t('proposta:detalhes_proposta.imobiliaria.errors.form.valor_invalido')),
            }),
            z.object({
              tipo: z.literal('valor'),
              valorCorretagemImobiliaria: z
                .number()
                .gt(0, t('proposta:detalhes_proposta.imobiliaria.errors.form.valor_invalido')),
            }),
          ]),
        }),
      )
      .superRefine((participacoes, ctx) =>
        validarImobiliariasCorretoresDuplicados(participacoes, ctx, {
          getImobiliariaCorretor: ({ imobiliariaCorretor }) => imobiliariaCorretor,
        }),
      ),
  }),
  z.object({
    incluirParticipacoes: z.literal('Não'),
  }),
  z.object({
    incluirParticipacoes: z.literal('').refine(() => false),
  }),
])
export type TImobiliariaCorretoresSchema = z.infer<typeof ImobiliariaCorretoresSchema>

export const AssinaturaContratoSchema = z
  .union([z.enum(assinaturaContratoEnum), z.literal('')])
  .refine((assinatura) => assinatura !== '', t('proposta:detalhes_proposta.assinaturas.required_error'))

export type TAssinaturaContratoSchema = z.infer<typeof AssinaturaContratoSchema>

export const detalhesPropostaSchema = z.object({
  detalhesDaProposta: z.object({
    imobiliariasCorretores: ImobiliariaCorretoresSchema,
    assinaturaContrato: AssinaturaContratoSchema,
    termosDaProposta: z.string().min(1),
    observacoes: z.string().nullish(),
    tipoEmolumento: z.enum(['AlienacaoFiduciaria', 'ContratoCompraVenda']).nullish(),
  }),
})
export type TDetalhesPropostaSchema = z.infer<typeof detalhesPropostaSchema>
